export enum DigitTypeEnum {
    None = 0,
    OneDigit = 1,
    TwoDigits = 2,
    ThreeDigits = 3,
    FourDigits = 4
}
